// import tocbot from 'tocbot'

export function toc() {
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
        const toc = document.querySelector('.table-of-contents');
        // table-of-contentsが無ければ何もしない
        if (!toc) {
          return;
        }

        const headings = document.querySelectorAll('.l-contents__inner h2');

        let sectionCount = 0;

        headings.forEach(function(heading) {
            if (!heading.id) {
                sectionCount++;
                heading.id = `section-${sectionCount}`;
            }
        });

        // 初期化して目次作成（ここだけで完結）
        tocbot.init({
            tocSelector: '.table-of-contents',
            contentSelector: '.l-contents__inner',
            headingSelector: 'h2:not(.fs-c-productList__list h2)',
            ignoreSelector: '.toc-ignore',
            hasInnerContainers: true,
            scrollSmooth: false,
            orderedList: false,
            activeLinkClass: 'is-active',
            headingsOffset: 300
        });

        // console.log('目次を初期化しました');
    }, 100);
  });

}
